export default "__VITE_ASSET__c21da595__"